import  { createContext, useEffect, useState, useCallback } from "react";
import Cookies from "js-cookie";
import { getMe } from "../api/authApi";

const Context = createContext();

export const AuthProvider = ({ children }) => {

  {/* Auth User States */}
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  {/* Page Title State */}
  const [pageTitle, setPageTitle] = useState("");

  {/* Sidebar State */}
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);

  {/* Sheets Common States */}
  const defaultColumns = ["Identifier", "Category", "Code", "Units", 'Time'];
  const defaultRow = Array(defaultColumns.length).fill("");
   const [currentSheet, setCurrentSheet] = useState({
    name: "",
    data: [defaultColumns, defaultRow],
  });
  const [validSheetData, setValidSheetData] = useState([]);
  const [allComments, setAllComments] = useState([]);
  const [currentSheetIndex, setCurrentSheetIndex] = useState(null);
  const [selectedSheetInfo, setSelectedSheetInfo] = useState({});
  const [sheetRestoredDate, setSheetRestoredDate] = useState(null);

  const fetchUser = useCallback(() => {
    const token = Cookies.get("authToken");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    getMe({}, (res) => {
      if (res?.status === true) {
        setUser(res.data);
        localStorage.setItem("userId", res.data.id);
        localStorage.setItem("company_id", res.data.company_id);
      } else {
        Cookies.remove("authToken");
        setUser(null);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <Context.Provider value={{ 
      /* Auth User States */
      user, setUser, loading, refreshUser: fetchUser, 

      /* Page Title State */
      pageTitle, setPageTitle,

      /* Sidebar State */
      isSidebarOpen, setSidebarOpen,

      /* Sheets Common States */
      defaultColumns, defaultRow, currentSheet, setCurrentSheet, validSheetData, setValidSheetData, allComments, setAllComments,
      currentSheetIndex, setCurrentSheetIndex, selectedSheetInfo, setSelectedSheetInfo, sheetRestoredDate, setSheetRestoredDate
      
      }}>
      {children}
    </Context.Provider>
  );
};

export default Context;
